//Library
import React, { useState, useEffect } from "react";

//Material
import { MuiHeader } from "../../stories/header2";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { BaseContainer } from "../../stories/base-container";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import parse from 'html-react-parser';


//Component
//Function
import { GetListFAQ } from "./api";
import pdfImage from '../../assets/pdf.png';
import { grey } from "@material-ui/core/colors";

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);


const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(1),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    table: {
        minWidth: 900,
    },
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(18),
        //flexBasis: '33.33%',
        flexShrink: 0,
    },
    headingHeader: {
        backgroundColor: "#F7F5F5",
    },
    detailHeader: {
        backgroundColor: "#FFF",
    },
    detail: {
        marginLeft: '5px',
        fontSize: theme.typography.pxToRem(15),
    }
}));
const options = {
    replace: (domNode) => {
      if (domNode.attribs && domNode.attribs.class === "remove") {
        return <></>;
      }
    }
  };
export const Faq = () => {
    const classes = useStyles();
    const [listFAQ, setListFAQ] = useState([]);
    const [expanded, setExpanded] = React.useState(false);
    const fetch = async () => {
        let res = await GetListFAQ();
        setListFAQ(res);
    }
    useEffect(() => {
        fetch();
    }, []);



    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };
    return (

            
                <Grid
                    container
                    spacing={0}
                    direction="column"
                    //alignItems="center"
                    // justify="center"
                    style={{ minHeight: "80vh" }}
                >
                    <Grid item xs={12} >
                        <Container component="main" maxWidth="lg">
                            <Typography component="h1" variant="h3" paragraph align="center">
                                Frequently Asked Questions
                            </Typography>
                            {listFAQ?.map((row, i) => (
                                <Accordion expanded={expanded === i} onChange={handleChange(i)}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                        className={classes.headingHeader}
                                    >
                                        <Typography className={classes.heading}>{row.FAQ_QUESTION}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails className={classes.detailHeader}>
                                        <Typography className={classes.detail}>
                                            {parse(row.FAQ_ANSWER, options)}
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            ))}
                        </Container>
                    </Grid>
                </Grid>
       

    );
};
export default Faq;